export const USER_FLAGS = ["customer", "staff", "accounting", "admin", "system_admin"];
export const BACKOFFICE_FLAGS = ["staff", "accounting", "admin", "system_admin"];
export function hasFlag(flags, flag) {
    if (!flags)
        return false;
    if (flags.includes("system_admin"))
        return true;
    return flags.includes(flag);
}
export function hasAnyFlag(flags, required) {
    if (!flags)
        return false;
    if (flags.includes("system_admin"))
        return true;
    return required.some((f) => flags.includes(f));
}
export function isBackoffice(flags) {
    return hasAnyFlag(flags, BACKOFFICE_FLAGS);
}
export function isSystemAdmin(flags) {
    return !!flags && flags.includes("system_admin");
}
/**
 * A profile that is a customer's — tolerant of documents written before `flags` was always an array.
 *
 * Deliberately not `hasFlag`: this asks whose record a document is rather than what its owner is
 * allowed to do, so a `system_admin` account is not counted as a customer the way it satisfies
 * every permission check.
 */
export function isCustomerProfile(profile) {
    return Array.isArray(profile.flags) && profile.flags.includes("customer");
}
